import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import config from './newConfig.js';
import { appendSearchParamsFromQuery } from '../../utils/urlUtils.js';
import styles from './NewSubHierarchyInfoWidget.less';
import tracking from '../../tracking/tracking.js';
import { EXPAND_SEO_LINKS, EXPLORE_SEO_LINKS } from '../../tracking/trackingNaming.js';
import { Desktop, Mobile, Tablet } from '../Utils/MediaComponents/MediaComponents.tsx';
import { getLocationName, getLocationQuery, getRealEstateType, getSiblingsHierarchyInfo, getUserIntent } from '../../selectors/selectors';
import TrackableLink from '../TrackableLink/TrackableLink';

export class NewSubHierarchyInfoWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: false,
    };
  }

  renderLinks = (subHierarchyLinks, maxCollapsed) => {
    const { locationQuery } = this.props;

    return subHierarchyLinks.map((link, index) => {
      const hideClassName = index >= maxCollapsed ? 'hide' : '';
      const linkWithSearchParams = appendSearchParamsFromQuery(link.key, locationQuery);
      return (
        <li
          data-index={index}
          key={link.key}
          className={`grid-item font-ellipsis one-third lap-one-half palm-one-whole ${hideClassName}`}
        >
          <TrackableLink
            href={linkWithSearchParams}
            onClick={() => tracking.report(EXPLORE_SEO_LINKS)}
            title={link.name}
          >
            {link.name}
          </TrackableLink>
        </li>
      );
    });
  }

  onExpandHandler = () => {
    this.setState({ isExpanded: true }, this.props.onExpand);
    tracking.report(EXPAND_SEO_LINKS);
  };

  renderSubHierarchyLinks = (subHierarchyLinksToRender, maxCollapsed) => {
    const { hierarchyLevel, geoType } = this.props;
    const { isExpanded } = this.state;
    const shouldCollapse = subHierarchyLinksToRender.length > maxCollapsed;
    const iconSource =
      'https://www.static-immobilienscout24.de/statpic/sales-journey/it/atlas/icons/4819b5fcd8d62e08ab1faf0cafb8bdfa_refresh.png';
    return (
      <>
        <div className={styles.main}>
          <ul className="grid grid-flex">
            {this.renderLinks(subHierarchyLinksToRender, isExpanded ? subHierarchyLinksToRender.length : maxCollapsed)}
          </ul>
        </div>
        {!isExpanded && shouldCollapse && (
          <div className={styles.linkLine}>
            <button type="button" className="link-text font-regular" onClick={this.onExpandHandler}>
              <img src={iconSource} alt="" /> {config.getLinkTextFor(hierarchyLevel, geoType)}
            </button>
          </div>
        )}
      </>
    );
  };

  render() {
    const {
      subHierarchyLinks,
      siblingsHierarchyInfo,
      geoType,
      hierarchyLevel,
      location,
      userIntent,
      realEstateType,
    } = this.props;
    let subHierarchyLinksToRender = subHierarchyLinks;
    if (hierarchyLevel === 'region') {
      subHierarchyLinksToRender = subHierarchyLinks.filter((s) => s.geoType === 'district');
    }
    const linksToRender =
      hierarchyLevel === 'city' && geoType === 'city'
        ? siblingsHierarchyInfo.sort((x, y) => x.name.localeCompare(y.name))
        : subHierarchyLinksToRender;
    if (linksToRender.length === 0) return null;
    return (
      <div
        data-userintent={userIntent}
        data-realestatetype={realEstateType}
        data-identifier="subHierarchyInfoWidget"
        className={styles.subHierarchyWidget}
      >
        <h2 id="sub-hierarchy-info-headline" className={styles.headline}>
          {config.getTitleFor(hierarchyLevel, location, geoType)}
        </h2>
        <Mobile render={() => this.renderSubHierarchyLinks(linksToRender, 5)} />
        <Desktop render={() => this.renderSubHierarchyLinks(linksToRender, 15)} />
        <Tablet render={() => this.renderSubHierarchyLinks(linksToRender, 10)} />
      </div>
    );
  }
}

NewSubHierarchyInfoWidget.propTypes = {
  subHierarchyLinks: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      key: PropTypes.string,
      geoType: PropTypes.string,
    }),
  ).isRequired,
  siblingsHierarchyInfo: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      key: PropTypes.string,
      geoType: PropTypes.string,
    }),
  ),
  hierarchyLevel: PropTypes.string.isRequired,
  geoType: PropTypes.string.isRequired,
  location: PropTypes.string,
  onExpand: PropTypes.func,
  userIntent: PropTypes.string,
  realEstateType: PropTypes.string,
  locationQuery: PropTypes.object.isRequired,
};

NewSubHierarchyInfoWidget.defaultProps = {
  location: '',
  onExpand: () => undefined,
  siblingsHierarchyInfo: [],
  userIntent: '',
  realEstateType: '',
};

const mapStateToProps = (state) => ({
  location: getLocationName(state),
  siblingsHierarchyInfo: getSiblingsHierarchyInfo(state),
  userIntent: getUserIntent(state),
  realEstateType: getRealEstateType(state),
  locationQuery: getLocationQuery(state),
});

export default connect(mapStateToProps)(NewSubHierarchyInfoWidget);
